import * as Sentry from '@sentry/react';
import { env } from './env';

let initialized = false;

const DUMMY_DSN = 'https://dummy@sentry.example.com/2';

export function initSentry(): void {
  if (initialized) {
    return;
  }
  const enabled = env.VITE_SENTRY_DSN !== DUMMY_DSN;
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_SENTRY_ENVIRONMENT,
    enabled,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
  initialized = true;
}

export { Sentry };
